import React from 'react'
import { Modal, Button, Divider, Typography, Space, Breadcrumb, Popconfirm } from 'antd'
import { useTranslation } from 'react-i18next' //语言包
import { GlobalModalStyle } from './style'
import { ResetIconOperation } from '../operation'
import { MiniWarning } from '../mininote'



const ForgetPasswordModal = (props) =>{
    const { t } = useTranslation();
    return(
      <>
        <GlobalModalStyle />
        <Modal
          className= {props.className}
          title={t('FogetPassword.Modal.title')}
          open={props.isModalOpen}
          onCancel={props.handleCancel}
          maskClosable={false}
          footer={[
            <Button key='submitJPrev' onClick={props.prevClick} type='default' className={props.current !== 0 ? 'isShow' : 'isHide'}>
              {t('FogetPassword.Button.submitJPrev')}
            </Button>,
            <Button key='submitNext' onClick={props.nextClick} type='default' className={props.current === 0 ? 'isShow' : 'isHide'}>
              {t('FogetPassword.Button.submitNext')}
            </Button>,
            <Button key='submitCom' onClick={props.saveClick} type='primary' className={props.current === 2 ? 'isShow' : 'isHide'}>
              {t('FogetPassword.Button.submitCom')}
            </Button>
          ]}
        >
          { props.children }
        </Modal>
      </>
    )
}

const AddAlarmMailModal = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
      <Modal
        className= {props.className}
        open={props.isModalOpen}
        title={t('All.Label.FloatingBox.addAlarmEmail')}
        onOk={props.handleOk}
        okButtonProps={{
          disabled: props.isAddEmailFlag,
          loading: props.loadingFlag,
        }}
        onCancel={props.handleCancel}
        maskClosable={false}
      >
        { props.children }
      </Modal>
    </>
  )
}

const NoticeInfoModal = (props) =>{
  return(
    <>
      <GlobalModalStyle />
       <Modal
          className= {props.className}
          open={props.isModalVisible}
          title={props.title}
          closable= {props.closable}
          onCancel={props.onCancel}
          footer={null}
          zIndex={10000}
        >
          { props.children }
       </Modal>
    </>
  )
}

const UserCenterModal = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
        <Modal
          className= {props.className}
          title={t('Common.Header.userCenter.userCenter.userInfo')}
          open={props.isOpen}
          onOk={props.handleUpdateUserInfo}
          onCancel={props.handleCancel}
          okText={t('All.Operation.submit')}
          cancelText={t('InterfaceMsg.502.btn')}
          okButtonProps={{ loading: props.isLoading }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          { props.children }
        </Modal>
    </>
  )
}

const EditModal  = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
      <Modal
        className= {props.className}
        title={ props.title }
        open={props.isModalOpen}
        onOk={props.handleOk}
        onCancel={props.handleCancel}
        okText={t('All.Operation.submit')}
        cancelText={t('InterfaceMsg.502.btn')}
        okButtonProps={{ disabled: props.isSubBtn }}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        { props.children }
      </Modal>
    </>
  )
}

const AddModal = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
      <Modal
          className= {props.className}
          title={t('deviceManage.addDeviceInfo.addDevice')}
          open={props.isModalOpen}
          onOk={props.handleOk}
          onCancel={props.handleCancel}
          okText={t('All.Operation.submit')}
          cancelText={t('InterfaceMsg.502.btn')}
          okButtonProps={{ disabled: props.isSubBtn }}
          cancelButtonProps={{ style: { display: 'none' } }}
      >
        { props.children }
      </Modal>
    </>
  )
}

const LogModal = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
      <Modal
        className= { props.className }
        title={t('Common.properName.log')}
        open={props.isShow}
        destroyOnClose 
        onCancel={props.close}
        cancelText={t('InterfaceMsg.502.btn')}
        cancelButtonProps={{ style: { display: 'none' } }}
        footer={null}    
      >
        { props.children }
      </Modal>
    </>
  )
}

const AddPsModal = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
      <Modal
        className= { props.className }
        title={<Typography.Text>{t('All.Label.FloatingBox.addPlant')}</Typography.Text>}
        open={props.isOpen}
        onCancel={props.handleCancel}
        footer={[
            <Space>
                <Button key='back' onClick={props.handleBack} className={props.addIndex > 0 && props.addIndex < 3 ? 'isShow' : 'isHide'}>
                    {t('All.Operation.back')}
                </Button>
                 {/* disabled={props.disabling} disabled={(addIndex===0 &&  firstForm.current?.serialIdValid) || (addIndex===1 &&  secondForm.current?.serialIdValid) ?false:true} */}
                <Button key='next' onClick={props.handleNext} disabled={props.disabling} className={(props.addIndex < 2 && props.firstValue.addType !== 'psId' && props.firstValue.addType !== '') ? 'isShow' : 'isHide'}>
                    {t('All.Operation.next')}
                </Button>
                <Button key='submit' type='primary' loading={props.loading} disabled={props.addIndex === 0 && props.disabling} className={(props.addIndex === 2 || props.firstValue.addType === 'psId' || props.firstValue.addType === '') ? 'isShow' : 'isHide'} onClick={props.handelOk}>
                    {t('All.Operation.submit')}
                </Button>
            </Space>,
        ]}
      >
        { props.children }
      </Modal>  
    </>
  )
}

const DataSetModal = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
      <Modal
        className= { props.className }
        title={
          <>
            <Space size={0}>
              <Typography.Text strong>{t('home.PsTotalData.Modal.title')}</Typography.Text>
              <ResetIconOperation reductClick={props.resetTotalSetting} confirm={false} size='large' />
            </Space>
    
            <Popconfirm
              open={props.isOpen}
              placement='bottom'
              title={<MiniWarning text={t('All.Result.Warning.title-maxParameters', { index: 5 })} />}
              onCancel={props.cancel}
              onConfirm={props.cancel}
              showCancel={false}
              okText={t('All.Operation.ok')}
              okType='default'
              icon={false}
            />
          </>
        }
        open={props.isModalOpen}
        onCancel={props.handleCancel}
        maskClosable={false}
        footer={[
          <Button
            key='submitCom'
            type='primary'
            onClick={props.saveHandel}
            loading={props.loadSave}
          >
            {t('All.Operation.submit')}
          </Button>,
        ]}
      >
        { props.children }
      </Modal>
    </>
  )
}

const ModalAlarmInfo = (props) =>{
  return(
    <>
      <GlobalModalStyle />
      <Modal
        className= { props.className }
        open={props.isModalOpen}
        onOk={props.handleOk}
        onCancel={props.handleCancel}
        footer={null}
      >
        { props.children }
      </Modal>
    </>
  )
}

const ModalAddThreshold = (props) =>{
  const { t } = useTranslation();
  return(
    <>
      <GlobalModalStyle />
      <Modal
        className= { props.className }
        title={t('All.Operation.Add.addThresholdAlarm')}
        open={props.isModalOpen}
        onOk={props.submitForm}
        okText={t('All.Operation.submit')}
        onCancel={props.handleCancel}
        cancelButtonProps={{ style: { display: 'none' } }}
        key={props.isModalOpen}
        maskClosable={false}
        okButtonProps={{ disabled: props.contacts.length <= 0 }}
      >
        { props.children }
      </Modal>
    </>
  )
}

export {ForgetPasswordModal, AddAlarmMailModal, NoticeInfoModal, UserCenterModal, EditModal, AddModal, LogModal, AddPsModal, DataSetModal, ModalAlarmInfo, ModalAddThreshold}